import { render, staticRenderFns } from "./achievementStudentTag.vue?vue&type=template&id=146f9fd2&scoped=true"
import script from "./achievementStudentTag.vue?vue&type=script&lang=js"
export * from "./achievementStudentTag.vue?vue&type=script&lang=js"
import style0 from "./achievementStudentTag.vue?vue&type=style&index=0&id=146f9fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f9fd2",
  null
  
)

export default component.exports